export const ROUTE_PATH = '/album/:id';

export const getRoute = (pms = { id: '' }) => ROUTE_PATH.replace(':id', pms.id);
